import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isValidCoordinate } from '../../utils/geo';
import { MAX_LABEL } from '../../utils/chat/attachments';
import MapGpsPicker from '../MapGpsPicker';
import Dialog from '../ui/Dialog';
import ActionBar from '../ui/ActionBar';
import Button from '../ui/Button';
import * as S from '../specimens/styles';

/*
 * A place chosen on the map, to send in a conversation (`map_pin`): a pin
 * dropped on the map -- or the coordinates typed, the pin's keyboard
 * equivalent (MapGpsPicker) -- and an optional label. Nothing is tracked:
 * this is the one place sent, when the person sends it.
 */
export default function PinPicker({ onPick, onClose }) {
  const { t } = useTranslation('chat');
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [label, setLabel] = useState('');
  const ok = lat !== '' && lng !== '' && isValidCoordinate(lat, lng);
  return (
    <Dialog title={t('attach.pinTitle')} onClose={onClose} dirty={ok || !!label} testId="chat-pin">
      <MapGpsPicker lat={lat} lng={lng} onChange={(a, b) => { setLat(a); setLng(b); }} showRecapture={false}
        hintText={t('attach.pinHint')} />
      <label style={S.label}>
        {t('attach.label')}
        <input value={label} onChange={(e) => setLabel(e.target.value)} maxLength={MAX_LABEL} style={S.input}
          dir="auto" data-testid="chat-pin-label" />
      </label>
      <ActionBar>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button variant="primary" disabled={!ok} data-testid="chat-pin-use"
          onClick={() => { onPick({ lat: Number(lat), lng: Number(lng), label }); onClose(); }}>
          {t('attach.usePlace')}
        </Button>
      </ActionBar>
    </Dialog>
  );
}
